module.exports = __webpack_public_path__ + "img/AT0000002588901.bd240e5d.png";